import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md"
import { FaHandHoldingHeart } from "react-icons/fa"
import DataTable from 'react-data-table-component';
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import "./master_categories.css";
import { IoMdArrowDropdown } from "react-icons/io";
import { BsFillCloudUploadFill } from "react-icons/bs"
import { BiSearch } from "react-icons/bi"
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toFormData } from "axios";
import { HiOutlineClipboardList } from "react-icons/hi"
import { VscSymbolColor } from "react-icons/vsc"

import { FileManager } from "../Components/FileManager";
import { NavbarComponent } from "../Components/navbar/NavComponent";
import useDebouncedValue from "../Utils/Debounce";
const Products = () => {
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("")
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState(null)
    const [Id, SetId] = useState(null)
    let navigate = useNavigate();
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('')
    const [subcategoryOptions, setSubcategoryOptions] = useState([]);
    const tableCustomStyles = {
        rows: {
            style: {
            },
        },
        cells: {
            style: {
                justifyContent: "center"
            },
        },
        headCells: {
            style: {
                color: "#5C5C5C",
                justifyContent: "center",
                color: "rgb(33,37,41)",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "28px",
            },
        },
    }
    const HandleMouse = (row) => {
        SetId(row.id)
    }
    const HandleRowmouseLeave = () => {
        SetId()
    }
    const [selectedCategoryId, setSelectedCategoryId] = useState({
        subcategory: "",
        category: ""
    });
    const [Categories, setCategory] = useState([])
    const categories = async () => {
        await axiosConfig.get("catlog/categories/?is_suspended=false").then(res => {
            setCategory(res.data.results)
        }).catch(error => {
            console.log(error)
        })
    }
    const [Subcategories, setSubcategory] = useState([])
    const subategories = async () => {
        await axiosConfig.get(`catlog/sub-categories/?category=${selectedCategoryId.category}&page_size=500&is_suspended=false`).then(res => {
            setSubcategory(res.data.results)
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        GetData();
        categories()
        subategories();
        const fetchCategories = async () => {
            await axiosConfig.get(`catlog/sub-categories/?page_size=500&is_suspended=false`).then(res => {
                setSubcategoryOptions(res.data.results)
            }).catch(error => {
                console.log(error)
            })
        };
        fetchCategories();
    }, [currentPage, RowPerPage, selectedCategoryId.category, selectedCategoryId.subcategory, selectedCategoryId.category]);

    const handleCategoryFilterChange = (selectedOption, name) => {
        setSelectedCategoryId({ ...selectedCategoryId, [name]: selectedOption.value });
    };
    const [search, SetSearch] = useState({
        search: ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const [Datafilter, SetDatafilter] = useState([])
    const [Data, SetData] = useState([])
    const GetData = async () => {
        setLoading(true);
        try {
            let url = `catlog/products/?page=${currentPage}&page_size=${RowPerPage}&subcategory=${selectedCategoryId.subcategory ? selectedCategoryId.subcategory : ""}&subcategory__category=${selectedCategoryId.category ? selectedCategoryId.category : ""}`;
            const response = await axiosConfig.get(url);
            SetData(response.data.results);
            setLoading(false);
            setTotalRows(response.data.count);
        } catch (error) {
            console.log(error);
        }
    };
    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
    }

    const HandleSearchDebounce = async () => {
        setLoading(true);
        try {
            const response = await axiosConfig.get(
                `catlog/products/?name=${debouncedSearchTerm}`
            );
            SetData(response.data.results);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`catlog/products/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const handleNaigate = () => {
        navigate("/dashboard/masters/products/add")
    }
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true
        },
        {
            name: "Name",
            selector: "name",
            cell: row => row.name,
            sortable: true
        },
        {
            name: "image",
            selector: row => <>
                <img className="image" src={row.image && row.image.image} alt={row.image && row.image.image} />
            </>,
            sortable: true

        },
        {
            name: "Sort",
            selector: "sort",
            cell: row => row.sort,
            sortable: true
        },
        {
            name: "Subcategory_name",
            selector: "Subcategory_name",
            cell: row => row.subcategory_name,
            sortable: true
        },
        {
            name: "weight",
            selector: "weight",
            cell: row => row.weight,
            sortable: true
        },
        {
            name: "ACTIONS",
            selector: row => {
                const HandleEdit = async () => {
                    navigate(`/dashboard/masters/products/${row.id}/edit`)

                }
                const DeleteAlert = (row) => {
                    console.log("row", row)
                    SetRowId(row.id)
                    SetAlertDeletePopupType("success")
                }
                const CancelAlerrt = () => {
                    SetAlertDeletePopupType("error")
                }
                const HandleDelete = async (row_id) => {
                    await axiosConfig.delete(`catlog/products/${row_id}/`).then(() => {
                        SetAlertDeletePopupType("error")
                        setDeletepopupType("success")
                        GetData();
                    }).catch((error) => {
                        setDeletepopupType("error")
                        SetAlertDeletePopupType("error")
                        console.log(error)
                    })
                }
                const handleRevive = async () => {
                    try {
                        const response = await axiosConfig.post(`catlog/products/${row.id}/revive/`)
                        setpopupType("success")
                        setMessage("Product revived successfully")
                        GetData()
                    } catch (error) {
                        console.log("Error While Reviving", error)
                    }
                }
                return (
                    <>
                        {Id === row.id ? (
                            row.is_suspended ? (
                                <FaHandHoldingHeart className="dashboard-tabe-data-actions" onClick={handleRevive} />
                            ) : (
                                <>
                                    <div className="row" >
                                        <div className="col-4">
                                            <MdOutlineEdit className="dashboard-tabe-data-actions" onClick={HandleEdit} />
                                        </div>
                                        <div className="col-4">
                                            <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={() => DeleteAlert(row)} />
                                        </div>
                                    </div>
                                </>
                            )
                        ) : (
                            <div className={`client-type ${row.is_suspended ? 'variable-background' : 'contract-background'}`}>
                                {row.is_suspended ? 'Suspended' : 'Active'}
                            </div>
                        )
                        }

                        {
                            AlertDeletePopupType === "success" &&
                            <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />
                        }
                    </>
                )

            }
        }
    ]

    useEffect(() => {
        HandleSearchDebounce();
    }, [debouncedSearchTerm]);
    return (
        <>
            <DashboardLayout>
                <div className="child-sidenav">
                    <NavbarComponent />
                    <div className="childnav-content">
                        <div className="button-pro">
                            <div className="cat-button">
                                <div className="btn" onClick={handleNaigate} >
                                    + Add New
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* <div className="space-flex">
                                <div className="col-6">
                                    <div className="flex">
                                        <div className="product-filter">
                                            <Select options={Categories.map(Categories => ({ value: Categories.id, label: Categories.name }))} placeholder="Select Category" value={Categories.find(res => res.value === selectedCategoryId.category)} onChange={(selectedOption) => handleCategoryFilterChange(selectedOption, "category")} required />
                                        </div>

                                        <div className="product-filter">
                                            <Select options={subcategoryOptions.map(Subcategories => ({ value: Subcategories.id, label: Subcategories.name }))} placeholder="Select Subcategory" value={Subcategories.find(res => res.value === selectedCategoryId.subcategory)} onChange={(selectedOption) => handleCategoryFilterChange(selectedOption, "subcategory")} required />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="space-flex">
                                    <div className="col-6">
                                        <div className="flex">
                                            <div className="product-filter">
                                                <Select options={Categories.map(Categories => ({ value: Categories.id, label: Categories.name }))} placeholder="Select Category" value={Categories.find(res => res.value === selectedCategoryId.category)} onChange={(selectedOption) => handleCategoryFilterChange(selectedOption, "category")} required />
                                            </div>

                                            <div className="product-filter">
                                                <Select options={subcategoryOptions.map(Subcategories => ({ value: Subcategories.id, label: Subcategories.name }))} placeholder="Select Subcategory" value={Subcategories.find(res => res.value === selectedCategoryId.subcategory)} onChange={(selectedOption) => handleCategoryFilterChange(selectedOption, "subcategory")} required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 input-with-icon">
                                        <span className="icon-product"><BiSearch /></span>
                                        <input type="text" className="input-control" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive marginTop">
                            <DataTable
                                columns={columns}
                                data={Data} pagination paginationTotalRows={totalRows}
                                paginationPerPage={RowPerPage}
                                paginationDefaultPage={currentPage}
                                onChangePage={(page) => setCurrentPage(page)}
                                paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                onSort={handleSort}
                                onRowMouseEnter={HandleMouse}
                                onRowMouseLeave={HandleRowmouseLeave}
                                paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                                progressComponent={<div className="loader-container">
                                    <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                </div>}
                                subHeaderComponent={
                                    <input type="text" className="form-control w-50" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />} />
                        </div>
                    </div>
                </div>
                {popupType != "" &&
                    <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="/dashboard/masters/products" Message={message} />
                }
                {deletePopupType != "" &&
                    <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
                }
            </DashboardLayout >
        </>
    )
}
export { Products }